<template>
  <div class="comp-footer">
    <div class="left" v-html="$site.footerLeft"></div>
    <div class="right" v-html="$site.footerRight"></div>
  </div>
</template>

<script>
export default {
  name: "ic-footer"
};
</script>

<style lang="scss" scoped>
.comp-footer {
  display: flex;
  justify-content: space-between;
  color: rgba(255, 255, 255, 0.5);
  ::v-deep a {
    color: rgba(255, 255, 255, 0.5);
    &:hover {
      color: $link-hover-color-light;
    }
  }
}
</style>
